import { render, staticRenderFns } from "./VerifyForm.vue?vue&type=template&id=3145936d&scoped=true"
import script from "./VerifyForm.vue?vue&type=script&lang=js"
export * from "./VerifyForm.vue?vue&type=script&lang=js"
import style0 from "./VerifyForm.vue?vue&type=style&index=0&id=3145936d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3145936d",
  null
  
)

export default component.exports